/* eslint-disable unicorn/prefer-query-selector */
import PropTypes from 'prop-types';
import { useRef, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export default function ClientOnlyPortal({ children, targetElementId }) {
  const ref = useRef();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    ref.current = document.getElementById(targetElementId);
    if (ref.current) {
      setMounted(true);
    }
  }, [targetElementId]);

  return mounted ? createPortal(children, ref.current) : null;
}

ClientOnlyPortal.propTypes = {
  children: PropTypes.node,
  targetElementId: PropTypes.any,
};
